import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
/**
 * A mostly unstyled button used to build buttons. Always use this instead of
 * `<button>`.
 */
export const ProtoButton = React.forwardRef(({ children, ...rest }, ref) => _jsx("button", { type: "button", ref: ref, css: {
        border: "none",
        padding: 0,
        background: "none",
        color: "inherit",
        ":not([disabled])": {
            cursor: "pointer",
        },
    }, ...rest, children: children }));
//# sourceMappingURL=button.js.map